module.exports = __webpack_public_path__ + "resource/img/iShop.9dc352e3.png";